import React, { useState } from 'react';
import { Alert, Button, Card, message, Progress, Spin, Steps, Typography } from 'antd';
import Layout from '../Layout';
import GoalsSettingPartA from "./HPC/GoalsSettingPartA";
import TimeManagementPartA from "./HPC/TimeManagementPartA";
import AccomplishmentInventoryPartA from "./HPC/AccomplishmentInventoryPartA";
import OnlineCoursePlan from "./HPC/OnlineCoursePlan";
import GroupProjectWorkPartB from "./HPC/GroupProjectWorkPartB";
import PostProjectReflectionsAndPBI from "./HPC/PostProjectReflectionsAndPBI";
import ObservationTemplatePartD from "./HPC/ObservationTemplatePartD";
import LearningOnlineCoursesPartE from "./HPC/LearningOnlineCoursesPartE";
import HoursSpentPartF from "./HPC/HoursSpentPartF";
import CompetencyProfile from "./HPC/CompetencyProfile";
import PlansAfterSchool from "./HPC/PlansAfterSchool";
import { API_CONFIG } from '../config/api';

const { Title, Text } = Typography;
const { Step } = Steps;


const SelfEvaluation = () => {
    const [currentStep, setCurrentStep] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [messageInfo, setMessageInfo] = useState(null); // For success/error messages
    const [error, setError] = useState(null);
    const [formData, setFormData] = useState({});
    const accessToken = localStorage.getItem('accessToken');
    const server_url = API_CONFIG.BASE_URL;

    // Define the steps with titles and corresponding components
    const steps = [
        {
            title: 'Goals Setting Part A',
            component: (
                <GoalsSettingPartA
                    server_url={server_url}
                    accessToken={accessToken}
                    onComplete={(data) => handleStepComplete(0, data)}
                    initialData={formData['Goals Setting Part A']}
                />
            ),
        },
        {
            title: 'Time Management Part A',
            component: (
                <TimeManagementPartA
                    server_url={server_url}
                    accessToken={accessToken}
                    onComplete={(data) => handleStepComplete(1, data)}
                    initialData={formData['Time Management Part A']}
                />
            ),
        },
        {
            title: 'Plans After School',
            component: (
                <PlansAfterSchool
                    server_url={server_url}
                    accessToken={accessToken}
                    onComplete={(data) => handleStepComplete(2, data)}
                    initialData={formData['Plans After School']}
                />
            ),
        },
        {
            title: 'Accomplishment Inventory Part A',
            component: (
                <AccomplishmentInventoryPartA
                    server_url={server_url}
                    accessToken={accessToken}
                    onComplete={(data) => handleStepComplete(3, data)}
                    initialData={formData['Accomplishment Inventory Part A']}
                />
            ),
        },
        {
            title: 'Online Course Plan',
            component: (
                <OnlineCoursePlan
                    server_url={server_url}
                    accessToken={accessToken}
                    onComplete={(data) => handleStepComplete(4, data)}
                    initialData={formData['Online Course Plan']}
                />
            ),
        },
        {
            title: 'Group Project Work Part B',
            component: (
                <GroupProjectWorkPartB
                    server_url={server_url}
                    accessToken={accessToken}
                    onComplete={(data) => handleStepComplete(5, data)}
                    initialData={formData['Group Project Work Part B']}
                />
            ),
        },
        {
            title: 'Post-Project Reflections & PBI Part C',
            component: (
                <PostProjectReflectionsAndPBI
                    server_url={server_url}
                    accessToken={accessToken}
                    onComplete={(data) => handleStepComplete(6, data)}
                    initialData={formData['Post-Project Reflections & PBI Part C']}
                />
            ),
        },
        {
            title: 'Observation Template Part D',
            component: (
                <ObservationTemplatePartD
                    server_url={server_url}
                    accessToken={accessToken}
                    onComplete={(data) => handleStepComplete(7, data)}
                    initialData={formData['Observation Template Part D']}
                />
            ),
        },
        {
            title: 'Learning Online Courses Part E',
            component: (
                <LearningOnlineCoursesPartE
                    server_url={server_url}
                    accessToken={accessToken}
                    onComplete={(data) => handleStepComplete(8, data)}
                    initialData={formData['Learning Online Courses Part E']}
                />
            ),
        },
        {
            title: 'Hours Spent Part F',
            component: (
                <HoursSpentPartF
                    server_url={server_url}
                    accessToken={accessToken}
                    onComplete={(data) => handleStepComplete(9, data)}
                    initialData={formData['Hours Spent Part F']}
                />
            ),
        },
        {
            title: 'Student’s Competency Profile',
            component: (
                <CompetencyProfile
                    server_url={server_url}
                    accessToken={accessToken}
                    onComplete={(data) => handleStepComplete(10, data)}
                    initialData={formData['Student’s Competency Profile']}
                />
            ),
        },
    ];

    // Handle step completion and store form data
    const handleStepComplete = (stepIndex, data) => {
        setFormData((prevData) => ({
            ...prevData,
            [steps[stepIndex].title]: data,
        }));
        if (stepIndex < steps.length - 1) {
            setCurrentStep(stepIndex + 1);
        } else {
            // All steps completed, optionally show a summary or finalize submission
            message.success('All forms completed successfully!');
        }
    };

    // Handle navigation
    const next = () => {
        if (currentStep < steps.length - 1) {
            setCurrentStep((prev) => prev + 1);
        }
    };

    const prev = () => {
        if (currentStep > 0) {
            setCurrentStep((prev) => prev - 1);
        }
    };

    return (
        <Layout>
            <Spin spinning={isLoading} style={{ color: "#FAD049" }} size="large" tip="Loading...">
                <div style={{ padding: 24, fontFamily: "Poppins, sans-serif" }}>
                    <Card style={{ fontFamily: "Poppins, sans-serif" }} bordered={false}>
                        <Title level={3} style={{ marginBottom: 0, fontFamily: "Poppins, sans-serif" }}>
                            HPC Evaluation
                        </Title>
                        <Text type="secondary" className="font-gotham">
                            Manage your self-evaluation forms and track your progress.
                        </Text>
                        {/* Progress Indicator */}
                        <Progress
                            percent={Math.floor(((currentStep + 1) / steps.length) * 100)}
                            status="active"
                            strokeColor="#EAB308"
                            style={{ fontFamily: "Poppins, sans-serif" }}
                        />

                    </Card>

                    {/* Show loading spinner or errors */}
                    {isLoading && <Spin style={{ fontFamily: "Poppins, sans-serif" }} />}
                    {error && <Alert message={error} type="error" style={{ fontFamily: "Poppins, sans-serif" }} />}
                    {messageInfo && (
                        <Alert
                            message={messageInfo}
                            type="success"
                            closable
                            style={{ fontFamily: "Poppins, sans-serif" }}
                            onClose={() => setMessageInfo(null)}
                        />
                    )}


                    {/* Current Step Content */}
                    <div className="steps-content">{steps[currentStep].component}</div>

                    {/* Navigation Buttons */}
                    <div className="steps-action"
                        style={{ marginTop: 24, textAlign: 'right', fontFamily: "Poppins, sans-serif" }}>
                        {currentStep > 0 && (
                            <Button style={{ margin: '0 8px', fontFamily: "Poppins, sans-serif" }} onClick={() => prev()}>
                                Back
                            </Button>
                        )}
                        {currentStep < steps.length - 1 && (
                            <Button type="primary" className="bg-yellow-500 hover:bg-yellow-600 text-black"
                                onClick={() => next()}>
                                Next
                            </Button>
                        )}
                        {currentStep === steps.length - 1 && (
                            <Button type="primary" className="bg-yellow-500 hover:bg-yellow-600 text-black"
                                onClick={() => message.success('All forms completed!')}>
                                Done
                            </Button>
                        )}
                    </div>
                </div>
            </Spin>
        </Layout>
    );
};

export default SelfEvaluation;